<ng-container *ngFor="let product of variablePricesMap | keyvalue">
  <ng-container *ngIf="!!product.value?.appPrice && partnerCurrency">
    <ng-container
      *ngIf="
        !!product.value?.appPrice?.pricesForEditions?.['']?.pricesForCurrencies?.[partnerCurrency]
          ?.pricesForFrequencies?.[0]?.pricingRules?.[0]?.price
      "
    >
      <mat-card appearance="outlined" class="product-custom-price-card">
        <mat-card-header>
          <glxy-avatar mat-card-avatar [name]="product.value?.name" [src]="product.value?.iconUrl"></glxy-avatar>
          <mat-card-title>{{ product.value?.name }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Enter the amount you'll spend each billing period.</p>
          <ng-container *ngIf="product.value?.appPrice">
            <billing-ui-variable-price-input
              (spendAmountChanged)="changeSpendAmount($event, product.value?.appPrice.appId, product.value.packageID)"
              [appPrice]="product.value?.appPrice"
              [currencyCode]="partnerCurrency"
            ></billing-ui-variable-price-input>
          </ng-container>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngFor="let pkg of variablePackagePricesMap | keyvalue">
  <ng-container *ngFor="let product of pkg.value | keyvalue">
    <ng-container *ngIf="!!product.value?.appPrice && partnerCurrency">
      <ng-container
        *ngIf="
          !!product.value?.appPrice?.pricesForEditions?.['']?.pricesForCurrencies?.[partnerCurrency]
            ?.pricesForFrequencies?.[0]?.pricingRules?.[0]?.price
        "
      >
        <mat-card appearance="outlined" class="custom-price-card">
          <mat-card-header>
            <glxy-avatar
              mat-card-avatar
              [name]="product.value?.packageName"
              [src]="product.value?.packageIconUrl"
            ></glxy-avatar>
            <mat-card-title>{{ product.value?.packageName }}</mat-card-title>
            <mat-card-subtitle>{{ product.value?.name }}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p>Enter the amount you'll spend each billing period.</p>
            <ng-container *ngIf="product.value?.appPrice">
              <billing-ui-variable-price-input
                (spendAmountChanged)="changeSpendAmount($event, product.value?.appPrice.appId, product.value.packageID)"
                [appPrice]="product.value?.appPrice"
                [currencyCode]="partnerCurrency"
              ></billing-ui-variable-price-input>
            </ng-container>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
